<script>

    import 'swiper/dist/css/swiper.css'

    import { swiper, swiperSlide } from 'vue-awesome-swiper';


  export default {
    props: ['category'],
    name: "information-box",
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 4,
          spaceBetween: 30,
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 3000,
          },
          navigation: {
            prevEl: '.category-filter__btn-prev',
            nextEl: '.category-filter__btn-next'
          },
          breakpoints: {
            1200: {
              slidesPerView: 3
            },
            992: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 1
            },
            576: {
              slidesPerView: 1
            }
          }
        }
      }
    },
  }
</script>

<template>



    <div class="vue-information-box">
        <div class="category-filter__information-box" v-if="$mq === 'lg'">
            <div class="container">
                <div class="row align-items-start justify-content-between">
                    <div class="catalog-filter__slider slider-container">
                        <div class="swiper-wrapper">
                            <div :class="{'col-m-6 col-l-2':(key === 0) || (key === 4), 'col-l-2': key !==0 && index !==key}" v-for="(model,key,index) in category.widgetCarouselItems">
                                <div class="swiper-slide">
                                    <div class="catalog-filter__item">
                                        <div class="catalog-filter__img">
                                            <img :src="model.image">
                                        </div>
                                        <div class="catalog-filter__text">
                                            <p class="catalog-filter__title">{{model.title}}</p>
                                            <p class="catalog-filter__subtitle">{{model.content}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="slider-arrow slider-arrow__prev">
                            <svg class="icon">
                                <use xlink:href="#ic-arr-left"></use>
                            </svg>
                        </button>
                        <button class="slider-arrow slider-arrow__next">
                            <svg class="icon">
                                <use xlink:href="#ic-arr-right"></use>
                            </svg>
                        </button>
                    </div>


                </div>
            </div>
        </div>

        <div class="category-filter__slider-box" v-if="$mq === 'sm'||$mq === 'md'">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <swiper class="category-filter__slider" :options="swiperOption" ref="category-swiper">
                            <swiper-slide v-for="(model,key) in category.widgetCarouselItems" :key="key">
                                <div class="information-box">
                                    <div class="information-box__icon">
                                        <img alt="icon" class="icon" :src="model.image"></div>

                                    <p class="information-box__title">{{model.title}}</p>

                                    <p class="information-box__sub-text">{{model.content}}</p>
                                </div>
                            </swiper-slide>
                            <div class="swiper-button-prev category-filter__btn-prev" slot="button-prev">
                                <svg class="icon icon-right-arrow ">
                                    <use xlink:href="static/img/svg/symbol/sprite.svg#right-arrow"></use>
                                </svg>
                            </div>
                            <div class="swiper-button-next category-filter__btn-next" slot="button-next">
                                <svg class="icon icon-right-arrow ">
                                    <use xlink:href="static/img/svg/symbol/sprite.svg#right-arrow"></use>
                                </svg>
                            </div>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
